import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const forgotPassword = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.LOGIN.FORGOT_PASSWORD,
    data
  );
};

export default forgotPassword;
